import { useState, useEffect } from 'react';
import { api } from '../lib/api.js';

// Hiring v3 / Ticket J1 — Hiring signals admin (feature flag + read).
// Surfaces the on/off toggle for the staffing-intelligence integration.
// When enabled, displays current signals (or empty list if engine hasn't
// written any yet — graceful degradation per spec §18.3).
export function HiringSettingsSignals({ currentUser }) {
  const headers = { 'x-user-id': String(currentUser.id) };
  const [data, setData] = useState({ enabled: false, signals: [] });
  const [loading, setLoading] = useState(true);
  const isOwner = /^(owner|admin|administrator)$/i.test(currentUser.role || '');

  async function load() {
    setLoading(true);
    try {
      const r = await api('GET', '/api/admin/hiring-signals', null, headers);
      setData({ enabled: !!r?.enabled, signals: Array.isArray(r?.signals) ? r.signals : [] });
    } catch (_) { setData({ enabled: false, signals: [] }); }
    finally { setLoading(false); }
  }
  useEffect(() => { load(); }, []);

  async function toggle() {
    if (!isOwner) return;
    try {
      // Settings flag lives in app_settings.hiring_signals_enabled. Owner
      // settings endpoint already exists at /api/admin/settings (key/val).
      await api('PUT', '/api/admin/settings/hiring_signals_enabled',
        { value: data.enabled ? 'false' : 'true' }, headers);
      await load();
    } catch (e) { alert(e.message || String(e)); }
  }

  return (
    <div className="card" style={{ padding: 16 }}>
      <div className="text-base font-semibold mb-1">Hiring signals</div>
      <div className="text-sm text-gray-500 mb-4">
        Decision-support hints from the Staffing Intelligence engine
        (separate system; nightly refresh). Disabled by default — toggle on
        when the engine is wired up. The widget gracefully hides when
        there's nothing to show.
      </div>
      {isOwner && (
        <button onClick={toggle}
          style={{ padding: '6px 14px', border: 0, borderRadius: 6, fontWeight: 600, fontSize: 13,
                    background: data.enabled ? '#a13030' : 'var(--gold)', color: '#fff', cursor: 'pointer' }}>
          {data.enabled ? 'Disable' : 'Enable'} hiring signals
        </button>
      )}
      {loading ? null : data.enabled ? (
        <div style={{ marginTop: 14 }}>
          <div style={{ fontSize: 11, color: '#888', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>
            Active signals · {data.signals.length}
          </div>
          {data.signals.length === 0 ? (
            <div style={{ fontSize: 12, color: '#888' }}>No active signals — engine has no recent input.</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {data.signals.map(s => (
                <div key={s.id} style={{ border: '1px solid #e0e0e0', borderRadius: 6, padding: 10, fontSize: 13 }}>
                  <strong>{s.role_needed}</strong> @ {s.location_name || '—'} · severity {s.severity}
                  <span style={{ color: '#888' }}> · persistent {s.weeks_persistent}w</span>
                </div>
              ))}
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
}
